var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { prependPath } from "@/utils/redirect";
import { rethrowSimple } from "@/utils/simple-error";
export function getCurrentUser() {
    return __awaiter(this, void 0, void 0, function* () {
        const url = prependPath("/api/users/current");
        const response = yield axios.get(url);
        if (response.status != 200) {
            throw new Error("Failed to get current user");
        }
        return response.data;
    });
}
export function addFavoriteToolQuery(userId, toolId) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = prependPath(`/api/users/${userId}/favorites/tools`);
        try {
            const { data } = yield axios.put(url, { object_id: toolId });
            return data["tools"];
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
export function removeFavoriteToolQuery(userId, toolId) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = prependPath(`/api/users/${userId}/favorites/tools/${encodeURIComponent(toolId)}`);
        try {
            const { data } = yield axios.delete(url);
            return data["tools"];
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
export function setCurrentThemeQuery(userId, theme) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = prependPath(`/api/users/${userId}/theme/${theme}`);
        try {
            const { data } = yield axios.put(url, { theme: theme });
            return data;
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
